var _a;
export const DEFAULT_TAGLINE_LENGTH = 150;
export const HOME_PAGE_BANNER_LENGTH = 5;
// skipcq: SCT-A000
export const ES_AUTH_KEY = 'AhkouChugh9jaehataeshahngothee7a';
export const GOOGLE_API = {
    key: 'AIzaSyCgd9ZUm8y93oCaA0QCAcxyXwi5Rk-gr1o',
    autocomplete: 'https://maps.googleapis.com/maps/api/place/autocomplete/json?key=AIzaSyCgd9ZUm8y93oCaA0QCAcxyXwi5Rk-gr1o&components=country:us|country:ca',
    placeDetails: 'https://maps.googleapis.com/maps/api/place/details/json?key=AIzaSyCgd9ZUm8y93oCaA0QCAcxyXwi5Rk-gr1o',
};
export const API_ROUTES = {
    admin: 'admin',
    domain: window.location.hostname,
    user: {
        login: '/api/login',
        location: '/api/profile/location',
    },
    // set the variable VENNGO_API_URL in your .env
    venngoApi: window.s.venngoApi,
    site: {
        check: '/api/site/check',
        forgotPassword: '/password/reset',
        register: '/register',
        keyword: '/keyword',
    },
    accessdevelopment: {
        endpoint: window.s.middlewareURL,
    },
    geocode: 'https://admin.venngo.com/api/location/geocode',
    elasticsearch: {
        perk: `/es/${window.l.locale && window.l.locale === 'fr' ? 'fr' : 'en'}/perks`,
        category: '/es/category',
        account: '/es/accounts',
        sponsored_keyword: '/es/keywords'
    },
    mobileApi: {
        endpoint: 'https://api.venngo.com',
    },
    template: '/api/template',
    google: {
        autocomplete: 'https://maps.googleapis.com/maps/api/place/autocomplete/json',
        placeDetails: 'https://maps.googleapis.com/maps/api/place/details/json',
    },
};
export const FIREBASE_CONFIG = ((_a = window.s.config) === null || _a === void 0 ? void 0 : _a.firebase) ? window.s.config.firebase : null;
export const DEFAULT_RESULT_SIZE = 10;
export const SEARCH_ON_TYPE_DEBOUNCE = 250;
export const SEARCH_ON_TYPE_MIN_LENGTH = 3;
export const MAX_RECENT_SEARCHES = 6;
export const EXPIRATION_DAYS_THRESHOLD = 10;
export const NEW_DAYS_THRESHOLD = 10;
export const KM_TO_MILE = 0.621371;
export const MILE_TO_KM = 1.60934;
export const PERK_NEW_THRESHOLD = 30;
export const USLocation = {
    address1: 'One Apple Park Way',
    address2: '',
    city: 'Cupertino',
    country: 'US',
    label: 'apple headquarter',
    latitude: '37.334644',
    longitude: '-122.008972',
    postal_code: '95014',
    primary: 0,
    province: 'CA',
    range: 50,
    visible: 1,
};
export const CALocation = {
    address1: '155 Rexdale Boulevard',
    address2: '',
    city: 'Toronto',
    country: 'CA',
    label: 'Venngo headquarter',
    latitude: '43.710977',
    longitude: '-79.568206',
    postal_code: 'M9W 5Z8',
    primary: 0,
    province: 'ON',
    range: 50,
    visible: 1,
};
export const SPONSORED_RESULT_FALSE = 0;
export const SPONSORED_RESULT_TRUE = 1;
